import { SubtaskItemController } from './subtask-item.controller'

function subtaskItemDirective () {
  return {
    restrict: 'E',
    scope: {
      subtask: '=',
      isArchived: '<',
      companyFeatures: '<',
      onChange: '=',
      isLast: '<'
    },
    templateUrl: '/workflow/directives/subtask-item/subtask-item-directive.html?$$REVISION$$',
    controller: SubtaskItemController
  }
}

export { subtaskItemDirective }
